export default __webpack_public_path__ + "d94b6dc05fe9c5140627393bd81844bc.png";